import { render, staticRenderFns } from "./SnsCommentMenu.vue?vue&type=template&id=08a8ce98&"
import script from "./SnsCommentMenu.vue?vue&type=script&lang=js&"
export * from "./SnsCommentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports